




































































































import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import AccountMetaList from '@core/pages/account/model/AccountMetaList'
import { CompanyDetailsMetaList } from '@core/pages/companyDetails/model/CompanyDetailsMetaList'
import { header } from '@core/pages/companyDetails/model/CompanyDetailsMeta'
import { isEmpty, sortBy } from 'lodash'
import { AccountStructureMemberService, CommissionRecordsService, DownloadCsvDto } from '../../api'
import AppDialog from '@core/components/AppDialog.vue'
import AppLoader from '@core/components/AppLoader.vue'

@Component({
  components: {
    AppDialog,
    AppLoader
  }
})
export default class DownloadCsv extends Vue {
  @inject()
  private $api: API

  private loading = false
  private companyFilter = ''
  private userFilter = ''
  private dateTypeFilter = ''
  private from = ''
  private to = ''
  private status: DownloadCsvDto.status = null
  private companies: CompanyDetailsMetaList = null
  private users: AccountMetaList = null
  private generatingReport = false
  private showSearchUserModal = false
  private searchUser = ''

  get companyFilterOptions () {
    const companies = !this.companies ? [] : this.companies.getFullList().map(company => {
      return {
        value: company.companyDetailsName,
        name: company.companyDetailsName
      }
    })

    const options = [
      {
        value: '',
        name: 'All Companies'
      },
      ...companies
    ]

    return options
  }

  get filteredUserOptions () {
    return this.userFilterOptions.filter(e => e?.name?.toString().toLowerCase().includes(this.searchUser.toLowerCase()))
  }

  get userFilterOptions () {
    const userList = this.users?.getFullList().map(user => {
      return {
        oid: user.oid,
        name: user.fullname || user.names[0]
      }
    }).filter(data => data)

    const sortUserList = sortBy(userList, ['name'])

    sortUserList.unshift({
      oid: '',
      name: 'All Users'
    })

    return sortUserList
  }

  get dateTypeFilterOptions () {
    const options = [
      {
        value: 'paymentDateMillis',
        label: 'Payment Date'
      },
      {
        value: 'statementDateMillis',
        label: 'Statement Date'
      }
    ]

    return options
  }

  get statusFilterOptions () {
    const options = [
      {
        value: null,
        label: 'All'
      },
      {
        value: 'unpaid',
        label: 'Unpaid'
      },
      {
        value: 'paid',
        label: 'Paid'
      }
    ]

    return options
  }

  async selectUser (user: { oid: string; name: string }) {
    const structurePath = await AccountStructureMemberService.findMemberInStructure(user.oid)
    alert(`User: ${user.name} in ${structurePath.join('/')}`)
    this.userFilter = user.oid
    this.showSearchUserModal = false
  }

  async downloadCsv () {
    const from = new Date(this.from).getTime()
    const to = new Date(this.to).getTime()

    if (isEmpty(this.to) || isEmpty(this.from) || isEmpty(this.dateTypeFilter)) {
      alert('Please fill in all inputs')
      return
    }

    try {
      this.generatingReport = true
      const res = await CommissionRecordsService.downloadCsv({
        company: this.companyFilter,
        user: this.userFilter,
        dateType: this.dateTypeFilter,
        from,
        to,
        status: this.status
      })

      const blob = new Blob([res], { type: 'text/csv' })
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, 'commission_records.csv')
      } else {
        const elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = 'commission_records.csv'
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
      }
    } catch (err) {
      this.generatingReport = false
      alert(err.message || err.response.data.message)
    }
    this.generatingReport = false
  }

  async fetchUserList () {
    try {
      this.loading = true
      const headers = [
        '_oid',
        'fullname',
        'names'
      ]

      const res = await this.$api.account.list({
        headers: JSON.stringify(headers)
      })

      this.users = new AccountMetaList(headers, res.data)
    } catch (error) {
      console.error(error)
      alert('Error in fetching user list')
    } finally {
      this.loading = false
    }
  }

  async fetchCompanyList () {
    try {
      this.loading = true
      const res = await this.$api.companyDetails.list({
        headers: JSON.stringify(header)
      })
      this.companies = new CompanyDetailsMetaList(res.data)
    } catch (error) {
      console.error(error)
      alert('Error in fetching company list')
    } finally {
      this.loading = false
    }
  }

  closeModal () {
    this.showSearchUserModal = false
    this.searchUser = ''
  }

  async mounted () {
    await this.fetchCompanyList()
    await this.fetchUserList()
  }
}
